import { restRequest } from "../redux/utilities";
export var AUTH = restRequest("AUTH");
export var SECURITY = restRequest("SECURITY");
export var GET_USERS = restRequest("GET_USERS");
export var GET_JOBPACKS = restRequest("GET_JOBPACKS");
export var GET_FEED = restRequest("GET_FEED");
export var GET_GROUPS = restRequest("GET_GROUPS");